<template>
  <v-app id="app">
    <v-navigation-drawer  v-model="drawer" dark app class="pt-4" color="black" right>
      <v-list dense>
        <v-list-item  @click="openChangePassword()">
          <v-list-item-icon class="mr-3"><v-icon>mdi-lock-reset</v-icon></v-list-item-icon>
          <v-list-item-content>Trocar Senha</v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-icon class="mr-3"><v-icon>mdi-logout</v-icon></v-list-item-icon>
          <v-list-item-content>Logout</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-card v-if="this.$route.name == 'home'" flat tile>
      <v-toolbar extended height="auto" color="black">
        <div class="d-flex flex-column align-start cont">
          <!-- <h1 style="text-align: left; font-size: 1.32rem;">DIAGEO</h1> -->
          <img
            class="diageo"
            src="./img/logo.png"
            width="75"
            alt="Logo Diageo"
          />
          <p>
            Bem vindo, <span class="text_orange">{{ user.scope ? user.scope.dsNome : "" }}</span>
          </p>
          <p>
            Faltam <span class="text_orange">{{ lastday }}</span>
            {{ this.dias > 1 ? "dias" : "dia" }} para o término desse mês.
          </p>
          <v-btn color="#FF8723" class="btnNovidades" to="/novidades"
            >Confira as novidades</v-btn
          >
        </div>
        <div>
          <v-app-bar-nav-icon
            color="#FF8723"
            @click="drawer = !drawer"
          ></v-app-bar-nav-icon>
        </div>
      </v-toolbar>
    </v-card>
    <v-main>
      <transition name="fade" mode="out-in" appear>
        <router-view> </router-view>
      </transition>
    </v-main>
        <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card class="d-flex justify-center flex-column pa-3">
        <div style="width: 100%; display: flex; justify-content: space-between;">
          <h3>Nova Senha</h3>
          <v-btn
          style="padding-right:0; margin: auto; margin-right: 0;"
          color="green darken-1"
          text
          @click="dialog = false"
        >
          <v-icon 
          x-small
          color="#FF8723"
          >mdi-close</v-icon>
        </v-btn>
        </div> 
        <v-text-field
          v-model="u.currentPassword"
          :append-icon="showActualPass ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required]"
          :type="showActualPass ? 'text' : 'password'"
          ref="currentPassword"
          name="input-10-1"
          solo
          color="#FF8723"
          label="Senha Atual"
          :error-messages="errorMessages"
          hint="Digite a senha atual."
          @click:append="showActualPass = !showActualPass"
        ></v-text-field>
        <v-divider></v-divider>
        <v-text-field
          solo
          v-model="u.newPassword"
          ref="newPassword"
          :append-icon="showNewPass ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.strongPassword]"
          :type="showNewPass ? 'text' : 'password'"
          color="#FF8723"
          name="input-10-2"
          label="Nova Senha"
          autocomplete="false"
          @click:append="showNewPass = !showNewPass"
        ></v-text-field>

        <v-text-field
          v-model="u.confirmNewPassword"   
          ref="confirmNewPassword"
          :append-icon="showConfirmNewPass ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.samePass]"
          :type="showConfirmNewPass ? 'text' : 'password'"
          color="#FF8723"
          solo
          name="input-10-3"
          label="Confirme a nova Senha"
          autocomplete="false"
          @click:append="showConfirmNewPass = !showConfirmNewPass"
        ></v-text-field>
        <v-btn
        class="mx-auto my-2"
        elevation="2"
        color="#FF8723"
        :loading="loading"
        style="width: 70%; height: 50px;"
        @click="savePassword"
      >
        Salvar Senha
      </v-btn>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<style>
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .3s;
}

.fade-enter-active {
  transition-delay: .3s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
@media (max-width: 375px) {
  .cont {
    font-size: 0.9rem !important;
  }
  .cont .btnNovidades {
    height: 30px !important;
    width: 170px !important;
    margin-top: 5px;
  }
  .cont .btnNovidades > * {
    font-size: 0.8rem;
  }
}
.v-window__next, .v-window__prev {
  margin: 0 6px !important;
}

</style>

<script>
export default {
  name: "app",
  data() {
    return {
      drawer: false,
      dias: 20,
      dialog: false,
      showActualPass: false,
      showNewPass: false,
      showConfirmNewPass: false,
      errorMessages: '',
      loading: false,
      formHasErrors: false,
      u: { currentPassword: "", newPassword: "", confirmNewPassword: "" },
      rules: {
        required: (value) => !!value || "Campo obrigatório.",
        min: (v) => v.length >= 8 || "Minímo 8 caracteres",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Email inválido.'
        },
        strongPassword: value => {
          const pattern = /^(?=(.*[a-z]){3,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()\-__+.]){1,}).{8,}$/
          return pattern.test(value) || 'Sua senha precisa conter ao menos uma letra, número e um caracter especial, e ter no mínimo 8 caracteres.'
        },
        samePass: value => { 
          return value === this.u.newPassword || "As duas novas senhas devem coincidir."
        }
      }
    };
  },
  computed: {
    user() {
      return this.$store.state.user != undefined
        ? this.$store.state.user
        : { first_name: "Meu Perfil" };
    },
    lastday() {
      var d = new Date();
      return (
        new Date(d.getYear(), d.getMonth() + 1, 0).getDate() - d.getDate() 
      );
    },
  },
  mounted() {
    var cookie = localStorage.getItem("cookieAccepted");
    if (cookie == "true") {
      this.showBottom = false;
    }
    if (this.$store.state.token !== '') { 
      this.$gtag.query('set', {
        id_usuario: this.$store.state.user.scope.idUsuario,
        session_key: this.$store.state.token
      })
    }
  },
  methods: {
    openChangePassword(){
      this.dialog = true;
    },
    savePassword() {
      this.formHasErrors = false

      Object.keys(this.u).forEach(f => {
        if (!this.u[f]) this.formHasErrors = true
        if (!this.$refs[f].validate(true)) this.formHasErrors = true
        
      this.$refs[f].validate(true)
      
      })
      
      if (this.formHasErrors) return;
      let newPassword = {
        idUsuario: this.$store.state.user.scope.idUsuario,
        sAtual: this.u.currentPassword,
        novaSenha: this.u.newPassword
      }
      fetch(this.$drink_uri + "/trocar-senha", {
        method: "OPTIONS",
        headers: { "Content-Type": "application/json",
      'Authorization': `Bearer ${localStorage.tokenDrink}`,
    },      credentials: "include",
        body: JSON.stringify(newPassword),
      })
      .then((response) => response.json())
      .then((resp) => {
        if (resp == 0) {
          alert('Senha Atual Incorreta!')
        }
        else if (resp == 1) {
          alert('Senha alterada com sucesso!')
          this.dialog = false
        }
      })
      .catch(err => {
        alert('Ocorreu um erro tente novamente!')
        window.console.log(err)
      })
    },
    logout() { 
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.replace("/login");
        })
        .catch(() => alert("Login invalido"));
    },
    stopYoutube() {
      const yt = this.$refs.youtube;
      if (yt != undefined) {
        yt.forEach((ref) => {
          ref.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
        });
      }
    },
    aceitarTermos() {
      this.showBottom = false;
      localStorage.setItem("cookieAccepted", true);
    },

    getYoutubeEmbed(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      const id = match && match[2].length === 11 ? match[2] : null;

      if (id) {
        return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=1&enablejsapi=1`;
      }

      return null;
    },
  },

  watch: {
    sliderCardapio() {
      this.stopYoutube();
    },
    sliderPromocao() {
      this.stopYoutube();
    }
  },
};
</script>
